import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Logo from "../assets/qlogo.png";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function Header() {
  const [showHeader, setShowHeader] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
  
      if (currentScrollY === 0) {
        // Hide header at top of page
        setShowHeader(false);
      } else {
        // Show header when scrolling up
        setShowHeader(currentScrollY < lastScrollY);
      }
  
      setLastScrollY(currentScrollY);
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <AnimatePresence>
      {showHeader && (
        <motion.header
          initial={{ y: -80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -80, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed top-0 left-0 w-full bg-black shadow-md z-50"
        >
          <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
            <div className="text-xl font-bold text-blue-600">
              <img className="w-[40%]" src={Logo} alt="Questa Logo"/>
            </div>

            {/* Desktop Nav */}
            <nav className="hidden text-xl font-bold md:flex gap-6 text-purple-600">
              <Link to="/" className="hover:text-blue-700">Home</Link>
              <a href="#features" className="hover:text-blue-700">Features</a>
              <a href="#pricing" className="hover:text-blue-600">Pricing</a>
              <a href="#contact" className="hover:text-blue-600">Contact</a>
              <Link to="/login" className="hover:text-blue-600">Login</Link>
              <Link to="/register" className="hover:text-blue-600">Register</Link>
            </nav>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle menu"
              >
                {menuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          <AnimatePresence>
            {menuOpen && (
              <motion.div
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.3 }}
                className="md:hidden bg-white shadow-inner"
              >
                <div className="flex flex-col p-4 gap-3 text-gray-700">
                  <a href="#features" onClick={() => setMenuOpen(false)}>Features</a>
                  <a href="#pricing" onClick={() => setMenuOpen(false)}>Pricing</a>
                  <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.header>
      )}
    </AnimatePresence>
  );
}
